import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { LocationStatus } from '@gtpl/shared-models/masters';

export class LocationsDTO {

    @ApiProperty()
    @IsOptional()
   locationId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    rackId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    zoneId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    columnId: number;

   
    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    levelId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    locationName: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    locationStatus:LocationStatus;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;



    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;
    
    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;


}